import qs from 'qs';
import { SettingsProps } from '@pages/types';

interface LoadingPageProps {
  settings?: SettingsProps;
}

const LoadingPage = ({ settings }: LoadingPageProps) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { id } = query as { id?: string };

  return (
    <div className="h-screen">
      <main className="flex h-full flex-col items-center justify-center gap-4">
        <div className="flex flex-col gap-1">
          <span className="text-4xl font-semibold text-gray-700">
            Processing Payment
          </span>
          <span className="text-base font-normal text-gray-700">
            Please wait while we verify your payment
          </span>
        </div>
        <div className="relative my-6 h-20 w-20">
          <svg
            className="h-full w-full animate-spin"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="50"
              cy="50"
              r="40"
              fill="none"
              stroke={settings?.primary_color || '#e5e7eb'}
              strokeWidth="10"
              opacity="0.3"
            />

            <circle
              cx="50"
              cy="50"
              r="40"
              fill="none"
              stroke={settings?.button_color || '#000000'}
              strokeWidth="10"
              strokeDasharray="125 125"
              strokeDashoffset="31.25"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <div className="flex flex-col items-center gap-1">
          <span className="text-lg font-semibold text-gray-700">
            Checking Payment
          </span>
          <span className="text-sm font-normal text-gray-600">
            Invoice: {id}
          </span>
        </div>
      </main>
    </div>
  );
};

export default LoadingPage;
